export default __webpack_public_path__ + "static/media/wallet-oldie.b8912df0.svg";